import styled, { keyframes } from 'styled-components';
import { Clear } from '@mui/icons-material';
import { Modal } from '@mui/material';

import { getColor, getZIndex, getFontWeight } from '@process-advisor/process-miner/shared/theme';
import { Title } from '@process-advisor/process-miner/components/shared/title';

export const StyledWrapper = styled(Modal)`
    display: flex;
    place-items: center;
    place-content: center;

    & > * {
        outline: none;
    }
`;

const modalEntry = keyframes`
    from { margin-top: -200px; opacity: 0 }
    to { margin-top: 0; opacity: 1 }
`;

export const StyledModal = styled.div<{ width: string }>`
    width: ${({ width }) => width};
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    background-color: ${getColor('white')};
    box-shadow: ${getZIndex('modal')};
    animation: ${modalEntry} .4s cubic-bezier(.4, 0, .2, 1) forwards;
`;

export const StyledHeader = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 10px;
`;

export const StyledTitle = styled(Title)`
    margin: 0;
    font-weight: ${getFontWeight('bold')};
`;

export const StyledIcon = styled(Clear)`
    cursor: pointer;
`;

export const StyledContent = styled.div`
    padding: 10px 14px;
    overflow: auto;
    max-height: calc(90vh - 104px);
`;

export const StyledFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    border-top: 1px solid #dfe1e6;
    background: #fff;
`;
